__turbopack_context__.v({
  "root": "Hqt86G_root",
  "stickyWrapper": "Hqt86G_stickyWrapper",
  "textContent": "Hqt86G_textContent",
});
